import { styled } from '@lsy-netline/netline-ui';
import { useTranslation } from 'react-i18next';

import { useOfflineCache } from 'hooks';
import { ErrorIcon } from 'icons';

import styles, { noConnectionClasses } from './NoConnection.styles';

const NoConnectionRoot = styled('div', { name: noConnectionClasses.$name })(styles);

const NoConnection = () => {
  const { t } = useTranslation();
  const { online } = useOfflineCache();

  if (online) {
    return null;
  }

  return (
    <NoConnectionRoot className={noConnectionClasses.root} data-testid="NoConnection-root">
      <ErrorIcon fontSize="small" />
      <span className={noConnectionClasses.message} data-testid="NoConnection-message">
        {t('errors.offline.no_connection')}
      </span>
    </NoConnectionRoot>
  );
};

export default NoConnection;
